import React from 'react'

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // This provides a smooth scrolling effect
    });
  };
  return (
    <div className=' mx-auto md:flex items-center justify-between p-4 lg:px-8 text-white mt-24 overflow-x-hidden'>

      <div className="">
        <p className=' footer-p uppercase'>Richmond <span className=' footer-p text-gray-500'>Ewur </span>Ackon
        </p>
        <p className=' footer-p uppercase'>Exploring Creativity, One Project at a Time
        </p>
      </div>
      <div className="">
        <ul className=' flex justify-between items-center'>
          <li className=''>
            <a href="#home" className=' text-white footer-links flex justify-between items-center hover:animate-pulse '>
              <span className=' mr-2'>LINKEDIN</span>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="white" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25" />
              </svg>

            </a>
          </li>
          <li className=' ml-3'>
            <a href="#home" className=' text-white footer-links flex justify-between items-center hover:animate-pulse'>
              <span className=' mr-2'>TWITTER</span>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="white" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25" />
              </svg>

            </a>
          </li>
          <li className=' ml-3'>
            <a href="#home" className=' text-white footer-links flex justify-between items-center  hover:animate-pulse'>
              <span className=' mr-2'>INSTAGRAM</span>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="white" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25" />
              </svg>

            </a>
          </li>
        </ul>
      </div>
      <div className="">
        <h1 className=' back-to-top  cursor-pointer text-gray-300 hover:animate-pulse' onClick={scrollToTop}>BACK TO TOP</h1>
      </div>

    </div>
  )
}

export default Footer